import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class DBlogGrid extends BaseComponent {
	
	constructor() {
		super();
		
		var dbLogGrid = this;
		setTimeout(function(){
			dbLogGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var dbLogGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-combo-box',
					label: 'Filter Field',
					itemid: 'filterField',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					value: 'level',
					postinit: function (combo) {
						combo.items = [
							{
								code: 'level',
								description: 'Level'
							},
							{
								code: 'loggerName',
								description: 'Logger Name'
							},
							{
								code: 'nodeId',
								description: 'Node Id'
							}
						];						
					}
				},				
				{
					tag: 'vaadin-text-field',
					itemid: 'filterValue',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Filter By',
					listeners: {
						input: {
							fn: function() {
								actionRefresh();
							},
							buffer: 2000
					    }
					}
				},	
				{
					tag: 'dl-action-button',
					itemid: 'view',
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_SYSTEM:READ'],
					children:[
						ElementUtil.makeIcon('lumo:eye', ' View')
					],
					listeners: {
						click: function() {							
							actionView(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'deleteAll',
					theme: 'error primary',
					'class': 'spacer-toolbar-item',
					style: 'float: right; margin-top: 18px;',									
					permissions: ['ADMIN_SYSTEM:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete All')
					],
					listeners: {
						click: function() {							
							actionDeleteAll();
						}
					}
				}				
			]
		});
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [				
				{						
					path: 'logId',
					header: 'Log Id',					
					width: '9em',
					hidden: true					
				},
				{
					path: 'eventDts',
					header: 'Event Date',
					direction: 'desc',
					'text-align': 'center',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.eventDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);
					},
					width: '5em'
				},				
				{						
					path: 'level',
					header: 'Level',
					'text-align': 'center',
					width: '5em'						
				},
				{						
					path: 'loggerName',
					header: 'Logger Name',						
					width: '5em'						
				},				
				{						
					path: 'nodeId',
					header: 'Node Id',
					'text-align': 'center',
					width: '5em'						
				},
				{
					path: 'message',
					header: 'Message',
					'text-align': 'center',
					'flex-grow': '1'
				}				
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'view').disabled = false; 						
					} else {
						ElementUtil.query(toolbar, 'view').disabled = true;
					}	
				}
			}
		});
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
					
					dbLogGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField,
						sortOrder: backingGrid.currentSortDirection,
						filterField: ElementUtil.query(toolbar, 'filterField').value,
						filterValue: ElementUtil.query(toolbar, 'filterValue').value
					};
					
					Service.getApplicationService().getLogRecords(dbLogGrid.currentFilter)
					.then(function(logs){
						loadMask.remove();
				
						grid.activeItem = null;
						grid.items = logs.data;
						
						dbLogGrid.fullDataSet = logs.data;						
						pagingToolbar.totalRecords = logs.totalNumber;
						pagingToolbar.updatePager();
					});					
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();
				}
			}
			
		});
		
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				var exportFilter = Object.assign({}, dbLogGrid.currentFilter || {});
				delete exportFilter.offset;
				delete exportFilter.max;
				Service.getApplicationService().exportLogRecords(exportFilter);
			}
		});

		var gridLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		dbLogGrid.append(gridLayout);
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);
		};		
		
		var actionView = function(record) {
			
			var viewWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'View Event',
				icon: 'lumo:eye',
				listeners: {
					ready: function() {
						
						viewWin.show();
						
						var getDetails = function(inputRecord) {
							var date = TimeUtil.parseDate(inputRecord.eventDts);						
							var formatedDate =  TimeUtil.formatDateStandard(date);
							var detailData = [
								{
									key: 'Log Id',
									value: inputRecord.logId
								},
								{
									key: 'Event Date',
									value: formatedDate
								},
								{
									key: 'Level',
									value: inputRecord.level
								},
								{
									key: 'Logger Name',
									value: inputRecord.loggerName
								},
								{
									key: 'Node Id',
									value: inputRecord.nodeId
								},
								{
									key: 'Sequence Number',
									value: inputRecord.sequenceNumber
								},
								{
									key: 'Source Class',
									value: inputRecord.sourceClass
								},
								{
									key: 'Source Method',
									value: inputRecord.sourceMethod
								},
								{
									key: 'Thread Id',
									value: inputRecord.threadId
								},
								{
									key: 'Message',
									value: inputRecord.message
								},
								{
									key: 'Stacktrace',
									value: inputRecord.stackTrace ? inputRecord.stackTrace : 'N/A'
								}
							];
							return detailData;
						};
						
						var details = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								{
									tag: 'div',									
									slot: 'primary',
									children: [
										{
											tag: 'dl-detail-table',
											itemid: 'table',
											style: ''											
										}
									]
								},
								{
									tag: 'dl-nextprev-toolbar',	
									itemid: 'nextPrev',
									slot: 'footer',
									listeners: {
										ready: function(event){
											event.target.updateData(dbLogGrid.fullDataSet);
											event.target.setSelectedRecord('logId', record.logId);
										},
										change: function(event) {
											grid.deselectItem(record);
											grid.selectItem(event.detail.item);
											record = event.detail.item;
											ElementUtil.query(details, 'table').updateDetails(getDetails(record));	
										}										
									}
								}
							]
						});
						viewWin.addToContentElement(details);
						ElementUtil.query(details, 'table').updateDetails(getDetails(record));						
						
					}
				}
			});
			
		};
		
		var actionDeleteAll = function() {
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete all DB logs?<br>(Server logs are unaffected.)',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing ALL DB Logs...');
							Service.getApplicationService().deleteAllLogRecords().then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed all DB logs' , {									
									theme: 'success'
								});
								actionRefresh();
							});							
						}
					},
					{
						text: 'No'
					}
				]
			});			
			
		};
		
	}
	
};
customElements.define('dl-dblog-grid', DBlogGrid);



